module.exports = __webpack_public_path__ + "img/00018.04ffed92.webp";